module.exports = __webpack_public_path__ + "static/media/product-integration.442773f2.svg";